import React, { useMemo, useRef } from 'react'
import Button from '../../components/Button'
import Loader from '../../components/Loader'
import styles from './styles.module.scss'
import { checked } from '../../assets/svg/other'
import { tests, results, notify } from '../../assets/svg/candidates'
import { add, remove, change, status, excel, print, interview, copy } from '../../assets/svg/footers'
import CustomSelect from '../../components/CustomSelect'
import Input from '../../components/Input'
import { useState } from 'react'
import Modal from './modal'
import { armyClasses, armyDistricts } from '../../assets/const'
import { useNavigate } from 'react-router-dom'
import Table from '../../components/Table'
import { Pagination } from '../../components/Pagination'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'
import { copyCandidate, deleteCandidate, exportCandidatesExcel, getCandidatesList, printAdmissionCertificate, printExamTickets, printInterviewSheet, setPage } from '../../actions/candidates'
import { getSchoolYears } from '../../actions/common'
import useDoubleClick from 'use-double-click'
import classNames from 'classnames'
import NoticeModal from './NoticeModal'
import GroupsModal from './GroupsModal'
import ResultsModal from './ResultsModal'
import StatusModal from './StatusModal'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'

const candidatesStatuses = [
  { name: 'Подтверждение документов', value: 1 },
  { name: 'Зарегистрировано', value: 2 },
  { name: 'Направлен в класс', value: 3 },
  { name: 'Архивная', value: 4 },
  { name: 'Отказано', value: 5 },
  { name: 'Нет мест', value: 6 },
  { name: 'Зачислен', value: 7 },
]


export default function Candidates() {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { data, form } = useSelector(state => state.candidates)
  const { schoolYears } = useSelector(state => state.common)

  const { pageCount, pageNumber } = form
  const { list, loading } = data

  const [candidateId, setCandidateId] = useState(null)
  const [selectedCandidate, setSelectedCandidate] = useState([])
  const [selectedIds, setSelectedIds] = useState([])
  const [noticeModal, setNoticeModal] = useState(false)
  const [groupsModal, setGroupsModal] = useState(false)
  const [resultsModal, setResultsModal] = useState(false)
  const [statusModal, setStatusModal] = useState(false)

  // Фильтр по дате создания: по умолчанию от месяца назад до сегодня
  const today = new Date()
  const monthAgo = new Date()
  monthAgo.setMonth(today.getMonth() - 1)

  const formatDate = (date) => date.toISOString().split('T')[0]

  const [dateFrom, setDateFrom] = useState(formatDate(monthAgo))
  const [dateTo, setDateTo] = useState(formatDate(today))
  const [armyClass, setArmyClass] = useState('')
  const [armyDistrict, setArmyDistrict] = useState('')
  const [schoolYear, setSchoolYear] = useState('')
  const [statusFilter, setStatusFilter] = useState('')

  useEffect(() => {
    // dispatch(getCandidatesList()) бесконечное ожидание
    dispatch(getSchoolYears())
  }, [pageNumber])


  const openModal = (candidate) => () => {
    setCandidateId(!!candidate ? candidate.xp_key : 'add')
    setSelectedCandidate(!!candidate ? candidate : 'add')
  }

  const closeModal = () => setCandidateId(null)

  const closeNoticeModal = () => setNoticeModal(false)

  const goHome = () => navigate('/')

  const select = (id) => {
    const newSelectedIds = selectedIds.includes(id)
      ? selectedIds.filter(i => i !== id)
      : [...selectedIds, id]
    setSelectedIds(newSelectedIds)
  }

  const [deleteConfirmation, setDeleteConfirmation] = useState(false)

  const pageClick = ({ selected }) => dispatch(setPage(selected))

  const selectedEmails = useMemo(() => list?.reduce((acc, { xp_key, email, calc_fio }) => selectedIds.includes(xp_key) ? [...acc, { id: xp_key, email, calc_fio }] : acc, []), [selectedIds, list])

  const currentFilters = { school_year_id: schoolYear, date_from: dateFrom, date_to: dateTo, status_id: statusFilter, war_arms: armyClass, war_districts: armyDistrict }

  const handleDelete = async () => {
    for (const id of selectedIds) {
      await dispatch(deleteCandidate(id))
    }
    setSelectedIds([])
    setDeleteConfirmation(false)
    dispatch(getCandidatesList(currentFilters))
  }

  const handleCopy = async () => {
    if (!selectedIds.length) return
    const newCandidate = await dispatch(copyCandidate(selectedIds[0]))
    if (newCandidate) dispatch(getCandidatesList(currentFilters))
  }

  return (
    <div className={styles.wrapper}>
      <Modal
        candidateId={candidateId}
        selectedCandidate={selectedCandidate}
        isOpen={!!candidateId}
        closeModal={closeModal}
        addMode={candidateId === 'add'}
      />
      <NoticeModal
        open={noticeModal}
        selectedEmails={selectedEmails}
        closeModal={closeNoticeModal}
      />
      <GroupsModal
        open={groupsModal}
        closeModal={() => setGroupsModal(false)}
      />
      <ResultsModal
        open={resultsModal}
        closeModal={() => setResultsModal(false)}
      />
      <StatusModal
        open={statusModal}
        closeModal={() => setStatusModal(false)}
        selectedIds={selectedIds}
        currentFilters={currentFilters}
      />
      <h1>Претенденты</h1>
      <div className={styles.filters}>
        <div className={styles.dateFilter}>
          <span className={styles.dateFilterLabel}>Фильтр по дате создания</span>
          <div className={styles.dateFilterInputs}>
            <Input title='C' fz={13} type='date' value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} />
            <Input title='По' fz={13} type='date' value={dateTo} onChange={(e) => setDateTo(e.target.value)} />
          </div>
        </div>
        <CustomSelect
          title='Год поступления'
          options={schoolYears}
          value={schoolYear}
          setFieldValue={(_, val) => setSchoolYear(val)}
          valuesName='schoolYear'
          withoutAll
        />
        <CustomSelect
          title='Статус'
          options={candidatesStatuses}
          value={statusFilter}
          setFieldValue={(_, val) => setStatusFilter(val)}
          valuesName='statusFilter'
          withoutAll
        />
        <CustomSelect
          title='Род войск родителей'
          options={armyClasses}
          value={armyClass}
          setFieldValue={(_, val) => setArmyClass(val)}
          valuesName='armyClass'
          withoutAll
        />
        <CustomSelect
          title='Военный округ родителей'
          options={armyDistricts}
          value={armyDistrict}
          setFieldValue={(_, val) => setArmyDistrict(val)}
          valuesName='armyDistrict'
          withoutAll
        />
        <Button className={styles.filterButton} onClick={() => dispatch(getCandidatesList({
          school_year_id: schoolYear,
          date_applicant_from: dateFrom,
          date_applicant_to: dateTo,
          status_id: statusFilter,
          war_arms: armyClass,
          war_districts: armyDistrict,
        }))}>Обновить</Button>
        <Button className={styles.filterButton} mode='bordered'>{checked()}Обновить данные по конкурсу</Button>
      </div>
      <div className={styles.modes}>
        <Button mode='white' onClick={() => setGroupsModal(true)}>{tests()}Испытания</Button>
        <Button mode='white' onClick={() => setResultsModal(true)}>{results()}Результаты</Button>
        <Button onClick={() => setNoticeModal(true)} mode='white' >{notify()}Извещения</Button>
      </div>
      <Pagination
        pageCount={pageCount}
        pageNumber={pageNumber}
        onPageChange={pageClick}
        loading={loading}
        single
      >
        {!!list?.length &&
          <Table style={{ marginTop: '1rem', maxHeight: 'none' }}>
            <thead>
              <tr>
                <th>ФИО</th>
                <th>Пол</th>
                <th>Дата создания</th>
                <th>Класс для поступления</th>
                <th>Образовательное учреждение</th>
                <th>Тип набора</th>
                <th>Ед. балл</th>
                <th>Итог. заключение (псих.)</th>
                <th>Ср. балл по табелю</th>
                <th>Экзаменационная группа</th>
                <th>Прошел по конкурсу</th>
                <th>Статус</th>
                <th>Готов к поступлению</th>
                <th>Состояние здоровья</th>
                <th>Номер</th>
                <th>Тип документа</th>
                <th>Серия документа</th>
                <th>Номер документа</th>
                <th>Кем выдан документ</th>
                <th>Когда выдан документ</th>
                <th>Семья</th>
                <th>Льгота</th>
                <th>Удалить</th>
              </tr>
            </thead>
            <tbody>
              {list.map((candidate) =>
                <CandidateItem
                  key={candidate.xp_key}
                  data={candidate}
                  openModal={openModal}
                  selectedIds={selectedIds}
                  select={select}
                />
              )}
            </tbody>
          </Table>
        }
      </Pagination>
      <div className={styles.rowCounters}>
        <span>Всего строк: {list?.length || 0}</span>
        <span>Выделено строк: {selectedIds.length}</span>
      </div>
      {deleteConfirmation && (
        <Confirmation
          title={`Удалить ${selectedIds.length} претендента(ов)?`}
          acceptConfirmation={handleDelete}
          rejectConfirmation={() => setDeleteConfirmation(false)}
        />
      )}
      <footer className={styles.footer}>
        <div>
          <Button className={styles.footerButton} mode='bordered' onClick={openModal()}>{add()}Добавить</Button>
          <Button className={styles.footerButton} mode='bordered' disabled={!selectedIds.length} onClick={() => setDeleteConfirmation(true)}>{remove()}Удалить</Button>
          <Button className={styles.footerButton} mode='bordered' onClick={openModal()}>{change()}Изменить</Button>
          <Button className={styles.footerButton} mode='bordered' disabled={!selectedIds.length} onClick={() => setStatusModal(true)}>{status()}Изменить статус</Button>
          <Button className={styles.footerButton} style={{ padding: '.5rem 0' }} onClick={() => dispatch(exportCandidatesExcel(currentFilters))}>{excel()}В Excel</Button>
          <Button className={styles.footerButton} style={{ padding: '.5rem 0' }} disabled={!selectedIds.length} onClick={() => dispatch(printExamTickets(selectedIds))}>{print()}Печать экзаменационных билетов</Button>
          <Button className={styles.footerButton} style={{ padding: '.5rem 0' }} disabled={!selectedIds.length} onClick={() => dispatch(printInterviewSheet(selectedIds))}>{interview()}Лист собеседования</Button>
          <Button className={styles.footerButton} style={{ padding: '.5rem 0' }} disabled={selectedIds.length !== 1} onClick={() => dispatch(printAdmissionCertificate(selectedIds[0]))}>{print()}Печать справки - подтверждения поступления</Button>
          <Button className={styles.footerButton} style={{ padding: '.5rem 0' }} disabled={selectedIds.length !== 1} onClick={handleCopy}>{copy()}Копировать</Button>
        </div>
        <Button mode='white' onClick={goHome}>Закрыть</Button>
      </footer>
    </div>
  )
}


const CandidateItem = ({
  data,
  openModal,
  selectedIds,
  select
}) => {

  const {
    date, child_class, xp_key, calc_fio, calc_status, sex, child_edu, stream,
    ready_to_admission, health_status, caption,
    documenttype, documentseria, documentnumber, documentwhogive, documentwhengive,
    calc_family, calc_benefits,
  } = data
  const [confirmation, setConfirmation] = useState(false);

  const selected = selectedIds?.includes(xp_key)
  const rowRef = useRef()

  // Определение класса цвета по статусу
  const getStatusClass = (status) => {
    switch (status) {
      case 'Подтверждение документов': return styles.statusPending
      case 'Зарегистрировано': return styles.statusRegistered
      case 'Направлен в класс': return styles.statusAssigned
      case 'Архивная': return styles.statusArchived
      case 'Отказано': return styles.statusRejected
      case 'Нет мест': return styles.statusNoPlaces
      case 'Зачислен': return styles.statusEnrolled
      default: return ''
    }
  }

  useDoubleClick({
    onSingleClick: () => select(xp_key),
    onDoubleClick: openModal(data),
    ref: rowRef,
    latency: 250
  });

  const acceptConfirmation = () => {
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  return (
    <>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Удалить претендента ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      <tr className={classNames(getStatusClass(calc_status), { [styles.selectedRow]: selected })} ref={rowRef}>
        <td>{calc_fio}</td>
        <td>{sex}</td>
        <td>{date}</td>
        <td>{child_class}</td>
        <td>{child_edu}</td>
        <td>{stream}</td>
        <td>{ }</td>
        <td>{ }</td>
        <td>{ }</td>
        <td>{ }</td>
        <td>{checked()}</td>
        <td>{calc_status}</td>
        <td>{ready_to_admission ? checked() : null}</td>
        <td>{health_status}</td>
        <td>{caption}</td>
        <td>{documenttype}</td>
        <td>{documentseria}</td>
        <td>{documentnumber}</td>
        <td>{documentwhogive}</td>
        <td>{documentwhengive}</td>
        <td>{calc_family}</td>
        <td>{calc_benefits}</td>
        <td><i className={styles.trash} onClick={(e) => { e.stopPropagation(); setConfirmation({ id: xp_key, name: calc_fio }); }}><BiTrash /></i></td>
      </tr>
    </>
  )
}